import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'components/utils/icon';
import './index.scss';

const DEFAULT = 'default';
const SOLID = 'solid';

const propTypes = {
  active: PropTypes.bool,
  aria: PropTypes.string,
  circle: PropTypes.bool,
  disabled: PropTypes.bool,
  handleOnClick: PropTypes.func,
  icon: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
};

const defaultProps = {
  active: false,
  aria: '',
  circle: false,
  disabled: false,
  handleOnClick: () => {},
  icon: '',
  label: '',
  type: DEFAULT,
};

const Button = ({
  active,
  aria,
  circle,
  disabled,
  handleOnClick,
  icon,
  label,
  type,
}) => {
  const solid = type === SOLID;

  const style = {
    default: !solid && !disabled,
    solid: (solid || active) && !disabled,
    circle,
    disabled,
    'has-label': !!label,
  };

  return (
    <div className={cx('button-wrapper', { 'has-label': !!label })}>
      <button
        aria-label={aria}
        className={cx('button', style)}
        disabled={disabled}
        onClick={() => handleOnClick()}
      >
        {icon ? <Icon name={icon} /> : null}
        {label ? <span className="button-label">{label}</span> : null}
      </button>
    </div>
  );
};

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
